export default __webpack_public_path__ + "d9f6ef7ff71b8f72bac76ab3f0d153f2.svg";